import React from 'react';
import classNames from "classnames";

import intl from "react-intl-universal";


import {ContextMenuInEditorItem, ContextMenuInEditorItemProps} from "./ContextMenuInEditorItem";
import {ContextMenuWithNavigation, ContextMenuWithNavigationItem} from '../ContextMenuWithNavigation';


import './ContextMenuInEditor.css';


export type ContextMenuInEditorItemInParams = Omit<ContextMenuInEditorItemProps, 'handleClose'> & {
    id: string;
    onClick: () => void;
}

export interface ContextMenuInlineProps {
    handleClose: () => void;
    itemGroups: ContextMenuInEditorItemInParams[][];
    isDark: boolean;
    isInline?: boolean;
    onNewOption?: () => void;
    filterQuery?: string;
    headerText?: string;
    onEmptyEnter?: () => void;
    maxWidth?: string;
    classname?: string
}


export const ContextMenuInEditor = (
    {
        itemGroups,
        handleClose,
        isDark,
        isInline,
        filterQuery,
        headerText,
        onNewOption,
        onEmptyEnter,
    }: ContextMenuInlineProps
) => {
    const handleItemClick = (item: ContextMenuWithNavigationItem) => {
        return item.meta.onClick();
    }

    const preparedItemGroups: ContextMenuWithNavigationItem[][] = itemGroups.map(
        group => group.map(
            item => ({
                id: item.id,
                getContent: (ctxMenuItem, meta, innerRef) => (
                    <ContextMenuInEditorItem
                        key={`ctx${ctxMenuItem.id}`}
                        innerRef={innerRef}
                        isInNavigationFocus={meta.isInNavigationFocus}
                        isActive={item.isActive}
                        onClick={meta.onClick}
                        Icon={item.Icon}
                        text={ctxMenuItem.textForFilter!}
                        className={item.className}
                    />
                ),
                preserveContextMenu: item.preserveContextMenu,
                condition: item.condition,
                text: item.text,
                meta: item,
                textForFilter: item.text,
            })
        )
    )

    return (
        <ContextMenuWithNavigation
            allowFilter={true}
            className={classNames({
                'ContextMenuInEditor body-medium': true,
                'ContextMenuInEditor--isInline': isInline,
            })}
            handleClose={handleClose}
            itemGroups={preparedItemGroups}
            isDark={isDark}
            onItemClick={handleItemClick}
            filterQuery={filterQuery}
            onEmptyEnter={onEmptyEnter}
            onNewOption={onNewOption}
            headerNode={(
                headerText ? (
                    <>
                        <div key={`header`}
                             className={'ContextMenuInEditor__header label-medium'}>{headerText}</div>
                        <div key={`divider`}
                             className='ContextMenuInEditor__divider ContextMenuInEditor__divider--wide'/>
                    </>
                ) : null
            )}
            notFoundNode={(
                <div
                    key={'not_found'}
                    className='ContextMenuInEditor__not-found'
                >
                    {intl.get('trigger-actions.no_result_found').d('No results')}
                </div>
            )}
        />
    )
}
